﻿import xmlActions from './xmlActions';
import responseActions from './responseActions';
import filterActions from './filterActions';
import sortingActions from './sortingActions';
import paginationActions from './paginationActions';

let actions = Object.assign({}, xmlActions, responseActions, filterActions, sortingActions, paginationActions);

export default actions;
